import { useAuth } from '../context/AuthContext';
import { UserRole } from '../types/user.types';

/**
 * Flags de papel usadas só para toggles de UI (não gateiam ação nem dado —
 * o recorte real vem do backend). Compartilhado entre DashboardEmendasPage e
 * EmendasVisaoGeralPage, que reimplementavam o mesmo cálculo duas vezes.
 */
export function useEmendaRoleFlags() {
  const { hasRole, user } = useAuth();
  const isAdmin = hasRole(UserRole.ADMIN);
  // Gestor da Parceria: atribuicao booleana sobre SECRETARIA, nao role proprio.
  const isGestor = Boolean(user?.gestorParceria);
  const isVereador = hasRole(UserRole.VEREADOR);
  const isWorkflow =
    hasRole(UserRole.ORCAMENTO) ||
    hasRole(UserRole.SECRETARIA) ||
    hasRole(UserRole.CONVENIOS) ||
    hasRole(UserRole.JURIDICO);
  const canFilterByVereador = !isVereador && (
    isAdmin ||
    hasRole(UserRole.ORCAMENTO) ||
    hasRole(UserRole.CAMARA) ||
    hasRole(UserRole.SECRETARIA) ||
    hasRole(UserRole.CONVENIOS) ||
    hasRole(UserRole.JURIDICO)
  );

  return { hasRole, user, isAdmin, isGestor, isVereador, isWorkflow, canFilterByVereador };
}
